export default "__VITE_ASSET__cM7IRxFc__"